module.exports = __webpack_public_path__ + "img/bottom.af9141d5.png";